module.exports = __webpack_public_path__ + "static/media/logo-footer.839f6d6c.svg";